var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/musical-note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3011 1.10083C13.4264 1.19531 13.5 1.34311 13.5 1.5V3.98896C13.5002 3.9965 13.5002 4.00404 13.5 4.01154V10.8686C13.5 11.7615 12.908 12.5463 12.0494 12.7916L11.1695 13.043C10.0822 13.3537 9 12.5373 9 11.4066C9 10.6467 9.50373 9.97893 10.2344 9.77018L11.7747 9.33007C12.204 9.20742 12.5 8.81503 12.5 8.36855V4.66287L6.5 6.37715V12.8686C6.5 13.7615 5.90804 14.5463 5.04944 14.7916L4.16945 15.043C3.08225 15.3537 2 14.5373 2 13.4066C2 12.6467 2.50373 11.9789 3.23436 11.7702L4.77472 11.3301C5.20402 11.2074 5.5 10.815 5.5 10.3685V6.01106C5.49983 6.0035 5.49983 5.99596 5.5 5.98845V3.5C5.5 3.27676 5.64799 3.08057 5.86264 3.01924L12.8626 1.01924C13.0135 0.976136 13.1758 1.00634 13.3011 1.10083Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMusic);
export default __webpack_public_path__ + "static/media/ic_music.eef100dc7e04169c83f277a9e7eb9188.svg";
export { ForwardRef as ReactComponent };